<template>
  <form
    class="form-wrapper"
    @submit.prevent="validateBeforeSubmit"
    @updateForm="handleInput"
  >
    <slot />
  </form>
</template>

<script>

export default {
  props: {
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.extendValidatorWithCustomRules()
  },
  methods: {
    validateBeforeSubmit () {
      console.log('validateBeforeSubmit()')
      this.$emit('submit', {})
      // return Promise.all(getAllChildren(this).map(field => field.validate())).then((formData) => {
      //   const data = {}
      //
      //   formData.map((val) => {
      //     data[Object.keys(val)[0]] = val[Object.keys(val)[0]]
      //   })
      //
      //   this.$emit('submit', data)
      // }).catch((errorData) => {
      //   this.errorMessage = errorData && errorData.message
      //   this.hasError = true
      //
      //   this.$emit('formError', this.errorMessage)
      // })
    },
    extendValidatorWithCustomRules () {
      // Extend VeeValidate $validator with custom rules
      // Eg.: this.$validator.extend('string',
      //  value => type of value === 'string'
      // )
    },
    handleInput (formData) {
      this.$emit('input', formData)
    }
  }
}
</script>

<style lang="scss">
.form-wrapper {
  padding: 0 $padding;
  fieldset {
    padding: 0;
    border: none;
  }
}
.content-generator {
  .form-wrapper {
    padding: 0;
  }
}
</style>
